import styled from "@emotion/native"
import { Spacing, Text } from "../../../ui-components"
import { Switch } from "react-native"
import { AutoPayListItem } from "./AutoPayListItem"
import type * as React from "react"
import { useCurrencyFormatter } from "../../../hooks"

type AutoPaySecondStepProps = {
  isLimitEnabled: boolean
  setIsLimitEnabled: (value: boolean) => void
  withdrawalLimit: number | undefined | null
  onPressWithdrawalLimit: () => void
  companyName: string
}

export function AutoPaySecondStep({
  isLimitEnabled,
  setIsLimitEnabled,
  withdrawalLimit,
  onPressWithdrawalLimit,
  companyName,
}: AutoPaySecondStepProps) {
  const { formatAmount } = useCurrencyFormatter()

  return (
    <Container>
      <AutoPayListItem
        label="Activate limit"
        rightElement={
          <Switch
            trackColor={{ false: "#000000", true: "#000000" }}
            thumbColor={isLimitEnabled ? "#FFFFFF" : "#FFFFFF"}
            onValueChange={setIsLimitEnabled}
            value={isLimitEnabled}
            style={{ alignSelf: "flex-end" }}
          />
        }
      />
      <Text fontSize={14} lineHeight={22} color="grayscale700">
        Control how much{" "}
        <Text fontSize={14} lineHeight={22} fontFamily="IBMPlexSans-Bold">
          {companyName}
        </Text>{" "}
        can withdraw from your account.
      </Text>
      {isLimitEnabled && (
        <>
          <AutoPayListItem
            onPress={onPressWithdrawalLimit}
            label="Withdrawal limit"
            rightElement={
              withdrawalLimit ? (
                <Text fontSize={18} lineHeight={26} fontFamily="IBMPlexSans-Medium">
                  {formatAmount({ value: withdrawalLimit, currencyCode: "USD" })}
                </Text>
              ) : undefined
            }
          />
          <Spacing top={8} />
          <Text fontSize={14} lineHeight={22} color="grayscale700">
            Choose the max withdrawal per transaction.
          </Text>
        </>
      )}
    </Container>
  )
}

const Container = styled.View`
  gap: 12px;
  padding-bottom: 60px;
`
